// extracted by mini-css-extract-plugin
module.exports = {"inline-flex":"LockIcon_inline-flex__1W6-r","svg":"LockIcon_svg__3oW9V"};